var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproval2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.0834V9.18336H13.7667V15.0834H2.25ZM3.81667 12.1667H12.1833V10.75H3.81667V12.1667ZM8 9.18336L4.28333 4.73336C4.28333 3.68891 4.64283 2.78891 5.36183 2.03336C6.08083 1.2778 6.96022 0.900024 8 0.900024C9.03978 0.900024 9.91917 1.2778 10.6382 2.03336C11.3572 2.78891 11.7167 3.68891 11.7167 4.73336L8 9.18336ZM8 6.90002L10.05 4.23336C9.96111 3.7408 9.72467 3.32597 9.34067 2.98886C8.95667 2.65186 8.50944 2.48336 7.999 2.48336C7.48856 2.48336 7.04167 2.65186 6.65833 2.98886C6.275 3.32597 6.03889 3.7408 5.95 4.23336L8 6.90002Z",
    fill: "#612FB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval2);
export default __webpack_public_path__ + "static/media/approval 2.955d4612e1728e3f8eb9fad8df6d775f.svg";
export { ForwardRef as ReactComponent };